import { render } from "./New-collection.vue?vue&type=template&id=2a2606fb&scoped=true"
import script from "./New-collection.vue?vue&type=script&lang=js"
export * from "./New-collection.vue?vue&type=script&lang=js"

import "./New-collection.vue?vue&type=style&index=0&id=2a2606fb&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a2606fb"]])

export default __exports__